import { convertSchemaToHtml } from '../assets/rich-text-renderer.js';

const CACHE_EXPIRATION_MS = 10 * 60 * 1000;

function getCachedProduct(handle) {
    const raw = sessionStorage.getItem(`product-${handle}`);
    if (!raw) return null;

    try {
        const parsed = JSON.parse(raw);
        if (Date.now() - parsed.timestamp < CACHE_EXPIRATION_MS) {
            return parsed.data;
        } else {
            sessionStorage.removeItem(`product-${handle}`);
            return null;
        }
    } catch (err) {
        return null;
    }
}

function setCachedProduct(handle, data) {
    const payload = {
        timestamp: Date.now(),
        data,
    };
    sessionStorage.setItem(`product-${handle}`, JSON.stringify(payload));
}

document.addEventListener("DOMContentLoaded", function () {
    async function fetchProductData(clickedHandle) {
        const cached = getCachedProduct(clickedHandle);
        if (cached) {
            return cached;
        }

        const response = await fetch(`https://rover-backend-temp-d7mex.ondigitalocean.app/product/${clickedHandle}/ca`);

        if (!response.ok) {
            throw new Error(`Err ${response.status}: ${response.statusText}`);
        }

        const data = await response.json();
        setCachedProduct(clickedHandle, data);
        return data;
    }

    async function fetchProductShopify(clickedHandle) {
        const response = await fetch(window.location.origin + `/products/${clickedHandle}.js`);

        if (!response.ok) {
            throw new Error(`Err ${response.status}: ${response.statusText}`);
        }

        const data = await response.json();
        return data;
    }

    async function fetchProductPageInformation(clickedHandle) {
        const completeUrl = `${window.location.origin}/products/${clickedHandle}`;
        const response = await fetch(completeUrl);

        if (!response.ok) {
            throw new Error(`Err ${response.status}: ${response.statusText}`);
        }

        const data = await response.text();
        return data;
    }

    function formatPrice(amount, currency) {
        let formatted = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: currency,
            minimumFractionDigits: 0
        }).format(amount);

        return formatted.replace(/^[A-Z]{2}\$/, "$");
    }

    function extractProductId(gid) {
        return gid.split("/").pop();
    }

    document.querySelectorAll(".product-card-influencers").forEach(element => {
        element.addEventListener("click", async function () {
            const productHandle = this.dataset.handle;
            if (!productHandle) {
                console.error("Product handle not found in data attribute.");
                return;
            }
            try {
                await getProductHandleFromAPI(productHandle);
            } catch (error) {
                console.error("Error fetching product data:", error);
            }
        });
    });

    document.querySelectorAll(".product-card-swatch").forEach(element => {
        element.addEventListener("click", async function () {
            const href = this.dataset.href;

            if (!href) {
                console.error("data-href not found.");
                return;
            }
            const match = href.match(/\/products\/([^?]+)/);
            const productHandle = match ? match[1] : null;
            const variantIdMatch = href.match(/variant=(\d+)/);
            const variantId = variantIdMatch ? variantIdMatch[1] : null;

            if (!productHandle) {
                console.error("Product handle could not be extracted from data-href.");
                return;
            }

            try {
                await getProductHandleFromAPI(productHandle, variantId)
            } catch (error) {
                console.error("Error fetching product data:", error);
            }
        });
    });


    async function getProductHandleFromAPI(productHandle, variantId = null) {
        document.querySelector(".featured-collection-influencers-opacity-loading").classList.add("is-loading");
        const productData = await fetchProductData(productHandle);
        const product = productData.items;
        saveProductToLocalStorage(productHandle);
        const variantEdges = product.variants.edges;
        const firstAvailableVariant = variantEdges.find(edge => edge.node.availableForSale)?.node;
        const variant = firstAvailableVariant;
        const variants = product.variants.edges;
        const price = formatPrice(variant.price.amount, variant.price.currencyCode);
        const compareAtPrice = variant.compareAtPrice ? formatPrice(variant.compareAtPrice.amount, variant.compareAtPrice.currencyCode) : null;
        const productId = extractProductId(product.id);
        const productVariantId = extractProductId(variant.id);
        const productVariantSelected = variantId;

        const productPageInformation = await fetchProductPageInformation(productHandle);
        const html = new DOMParser().parseFromString(productPageInformation, 'text/html');
        const getJsonProductPageInformation = html.querySelector("#variants-information-preorder").textContent;
        const getJsonProductPageInformationObject = JSON.parse(getJsonProductPageInformation);


        if (compareAtPrice) {
            document.querySelector(".price_of").innerText = compareAtPrice;
        }
        const productForm = document.querySelector("product-form");
        const section = productForm.dataset.section;

        const htmlFirstVariant = `<div id="rarely-available-container" style="display: none; background: rgb(234, 133, 55); border-radius: 20px; font-family: Urbanist, sans-serif; font-size: 9px; font-weight: 700; color: rgb(255, 255, 255); padding: 5px 13px; margin-left: 25px; line-height: 13px;">
                        <img src="https://cdn.shopify.com/s/files/1/0882/1761/6684/files/Vector.svg?v=1731622375" style="width: 9.6px; vertical-align: middle; margin-right: 4px;" alt="Icon">
                        <span id="rarely-available-text"></span>
                     </div>`;

        const newColorsMetafield = product.metafields.find(
            mf => mf?.key === 'new_colors' && mf?.namespace === 'custom'
        );

        const newColorsArray = newColorsMetafield && newColorsMetafield.value
            ? newColorsMetafield.value.split(",").map(c => c.trim())
            : [];

        // Loop through each variant
        const bedSizes = new Set();
        const colors = new Set();
        const variantMap = {}; // Mapeia [bedSize][color] => variant

        variants.forEach(({ node }) => {
            const options = node.selectedOptions;
            const bedSize = options.find(opt => opt.name === "Bed Size")?.value;
            const color = options.find(opt => opt.name === "Color")?.value;

            if (color) colors.add(color);
            if (bedSize) bedSizes.add(bedSize);

            const keyBed = bedSize || "_";
            const keyColor = color || "_";
            if (!variantMap[keyBed]) variantMap[keyBed] = {};
            variantMap[keyBed][keyColor] = node;
        });

        // Tornar variantMap acessível globalmente
        window.variantMap = variantMap;

        // Limpa variações anteriores
        const variationsContainer = document.querySelector(".variations");
        variationsContainer.innerHTML = "";

        // Renderiza Bed Sizes se existirem
        if (bedSizes.size > 0) {
            const bedSizeFieldset = document.createElement("fieldset");
            bedSizeFieldset.className = "product-form__input product-form__input--block";
            bedSizeFieldset.dataset.index = "option1";
            bedSizeFieldset.dataset.handle = "bed-size";

            bedSizeFieldset.innerHTML += `
              <div class="form__label" style="text-transform: capitalize;">
                Bed Size:<span class="form__label__value" style="padding-left:5px; margin-right: 0px;"></span>
              </div>`;

            // Separar tamanhos por disponibilidade
            const availableSizes = [];
            const unavailableSizes = [];

            [...bedSizes].forEach((size) => {
                const variantEntry = variantMap[size];
                let hasAvailableVariant = false;

                if (variantEntry) {
                    Object.values(variantEntry).forEach((variant) => {
                        if (variant && variant.availableForSale) {
                            hasAvailableVariant = true;
                        }
                    });
                }

                if (hasAvailableVariant) {
                    availableSizes.push(size);
                } else {
                    unavailableSizes.push(size);
                }
            });

            // Criar array ordenado: disponíveis primeiro, depois indisponíveis
            const sortedSizes = [...availableSizes, ...unavailableSizes];

            sortedSizes.forEach((size, i) => {
                const id = `bed-size-${i}`;
                const label = size.charAt(0);
                const variantEntry = variantMap[size];
                let dataAttrs = '';
                let isPreorder = false;

                if (variantEntry) {
                    Object.entries(variantEntry).forEach(([color, variant]) => {
                        const normalizedColor = color.toLowerCase().replace(/\s+/g, '_');
                        const variantId = extractProductId(variant.id);
                        if (variant.availableForSale && variant.quantityAvailable <= 0) {
                            isPreorder = true;
                        }
                        dataAttrs += ` data-${normalizedColor}-variant-id="${variantId}" data-${normalizedColor}-pre-order="${isPreorder}"`;
                    });
                }

                bedSizeFieldset.innerHTML += `
                  <div style="position: relative; margin-bottom: 10px;">
                    <input type="radio" id="${id}" name="Bed Size" value="${size}">
                    <label for="${id}" data-product-id="${productId}" data-product-handle="${productHandle}"${dataAttrs}>
                      <span>${label}</span>
                    </label>
                  </div>`;
            });
            variationsContainer.appendChild(bedSizeFieldset);
        }

        // Renderiza Colors se existirem
        if (colors.size > 0) {
            const colorFieldset = document.createElement("fieldset");
            colorFieldset.className = "product-form__input product-form__input--color product-form__input--color--regular";
            colorFieldset.dataset.index = "option2";
            colorFieldset.dataset.handle = "color";

            colorFieldset.innerHTML += `
              <div class="form__label">
                <div style="text-transform: capitalize;">
                  <span class="form__label__text"><strong>Color:</strong></span>
                  <span class="form__label__value" style="padding-left:0px; margin-right: 0px;"></span>
                </div>
              </div>`;

            const newColorsMetafield = product.metafields.find(
                mf => mf?.key === 'new_colors' && mf?.namespace === 'custom'
            );
            const newColorsArray = newColorsMetafield && newColorsMetafield.value
                ? newColorsMetafield.value.split(",").map(c => c.trim())
                : [];

            // Separar cores por disponibilidade
            const availableColors = [];
            const unavailableColors = [];

            [...colors].forEach((color) => {
                const variantEntry = Object.entries(variantMap).find(([, colorMap]) => colorMap[color]);
                const variant = variantEntry ? variantEntry[1][color] : null;
                const isAvailable = variant && variant.availableForSale;

                if (isAvailable) {
                    availableColors.push(color);
                } else {
                    unavailableColors.push(color);
                }
            });

            // Criar array ordenado: disponíveis primeiro, depois indisponíveis
            const sortedColors = [...availableColors, ...unavailableColors];

            sortedColors.forEach((color, i) => {
                const id = `color-${i}`;
                let variantImageUrl = "";
                let customVariantColor = "";
                const variantEntry = Object.entries(variantMap).find(([, colorMap]) => colorMap[color]);
                const variant = variantEntry ? variantEntry[1][color] : null;
                const variantTitle = variant.title.split('/').pop().trim();
                const getInformationVariantPreorder = getJsonProductPageInformationObject[productVariantId];

                const isPreorder = variant.availableForSale && (variant.quantityAvailable <= 0 || getInformationVariantPreorder.force_pre_order_behavior === 'true');

                const isUnavailable = !variant.availableForSale;

                if (variant) {
                    if (product.metafield?.references) {
                        product.metafield.references.edges.forEach(metaobject => {
                            const fields = metaobject.node.fields;
                            const labelField = fields.find(field => field.key === "label");
                            const imageField = fields.find(field => field.key === "image");

                            if (labelField && labelField.value === variantTitle && imageField) {
                                variantImageUrl = imageField.reference.image.url;
                            }
                        });
                    }

                    productData.aditionals?.forEach(additional => {
                        if (additional.metaobject_colors?.values?.some(c => c.label === variantTitle)) {
                            customVariantColor = additional.custom_cor;
                        }
                    });
                }

                variantImageUrl = variantImageUrl || "/cdn/shop/files/default_image.jpg";

                const borderStyle = customVariantColor && customVariantColor !== "#ffffff"
                    ? `border: 3px ${customVariantColor} solid; position:relative; margin-top:4px;`
                    : newColorsArray.includes(variant?.title)
                        ? `border: 3px #956793 solid; position:relative; margin-top:4px;`
                        : "";

                const newBadge = (customVariantColor && customVariantColor !== "#ffffff") || newColorsArray.includes(variant?.title) ? `
                <div style="
                  position: absolute;
                  top: -8px;
                  left: 28px;
                  background: ${customVariantColor && customVariantColor !== "#ffffff" ? customVariantColor : '#956793'};
                  color: white !important;
                  padding: 0px 2px;
                  font-size: 10px;
                  text-transform: uppercase;
                  font-weight: bold;
                  z-index: 5;">
                  NEW
                </div>` : '';

                colorFieldset.innerHTML += `
                <div style="position: relative; margin-bottom: 10px;" class="variant-input-label">
                  <input type="radio" id="${id}" name="Color" value="${color}" ${isUnavailable ? 'class="is-disabled"' : ''}>
                  <label for="${id}" data-variant-quantity="${variant.quantityAvailable}" data-variant-id="${variant ? extractProductId(variant.id) : ''}" data-product-id="${productId}" data-product-handle="${productHandle}" data-pre-order="${isPreorder}"
                  style="
                    --option-color: ${color.toLowerCase()};
                    --option-color-image: url('${variantImageUrl}?&width=40&format=webp&quality=80');
                    ${borderStyle}
                  ">${color}</label>
                  ${newBadge}
                </div>`;
            });
            variationsContainer.appendChild(colorFieldset);
        }


        window.variantsColors = productData.aditionals;

        //pegar o primeiro div class form__label e inserir no final do elemento htmlFirstVariant
        const firstLabel = variationsContainer.querySelector(".form__label");
        if (firstLabel) {
            firstLabel.insertAdjacentHTML("beforeend", htmlFirstVariant);
        }

        // Scarcity
        const rarelyAvailableDiv = document.createElement("div");
        rarelyAvailableDiv.className = "rarely-available-message";

        variationsContainer.appendChild(rarelyAvailableDiv);

        const rarelyAvailableContainer = document.querySelector(".rarely-available-message");

        variants.forEach((variant) => {
            const variantId = extractProductId(variant.node.id);
            const scarcity = variant.node.metafields?.find(f => f?.key === "scarcity_warning_variant")?.value || "";
            const rarelyAvailable = variant.node.metafields?.find(f => f?.key === "rarely_available_badge_variant")?.value || "";

            rarelyAvailableContainer.innerHTML += `
                    <span
                        style="display:none;"
                        data-variant-id="${variantId}"
                        data-rarely-available-metafield="${rarelyAvailable}"
                        data-scarcity-metafield="${scarcity}">
                    </span>
                `;
        });


        //Price
        document.querySelector(".price_for").innerText = price;
        document.querySelector(".product-title").innerText = product.title;
        //Product Id form
        document.querySelector('input[name="id"]').value = productVariantId;
        document.querySelector('input[name="product-id"]').value = productId;
        //media
        const sliderContainer = document.querySelector("product-slider");
        sliderContainer.innerHTML = ""; // Limpa o conteúdo existente

        product.media.nodes.forEach((media, index) => {
            const idMedia = extractProductId(media.id);
            const typeMedia = media.mediaContentType;
            const isActiveClass = index === 0 ? "is-active" : "";

            let dataSetName = '';
            let dataGroup = '';
            let classVariante = '';
            let contentMedia = '';
            let imageSetFull = '';

            const getInformationVariantPreorder = getJsonProductPageInformationObject[productVariantId];
            const isPreorder = variant.availableForSale && (variant.quantityAvailable <= 0 || getInformationVariantPreorder.force_pre_order_behavior === 'true');

            if (media.previewImage.altText && media.previewImage.altText.includes('#')) {
                classVariante = 'product-images__slide-item--variant';
                imageSetFull = media.previewImage.altText.split('#').pop();
                if (imageSetFull.includes('_')) {
                    dataSetName = imageSetFull.split('_')[0];
                    dataGroup = imageSetFull;
                }
            }

            const badgesVariant = () => {
                return `
                    <div class="vg-badge-right vg-badge-right-first-image badge-top-align" style="position: relative; width: 100%; padding: 0 3%; z-index: 10; margin-top: 3%;">
                        <div class="vg-badge-right vg-badge-right-first-image badge-top-align">
                            <div class="vg-badge-right-on-sale">
                                <span class="badge onsale">
                                    ${(((variant.compareAtPrice.amount - variant.price.amount) * 100) / variant.compareAtPrice.amount).toFixed(0)}% OFF
                                </span>
                            </div>
                            <img src="https://rovelab.ca/cdn/shop/files/ready-to-ship_WB_1.svg?v=1746192417&width=100" alt="Custom Badge" height="23" loading="lazy" width="100" class="vg-img-right vg-img-right-first-image" style="display: ${isPreorder ? 'none' : 'inline-block'};">
                        </div>
                    </div>
                `
            }


            if (typeMedia == "VIDEO") {
                let posterVideo = media.previewImage.url;
                let video = media.sources[0].url;
                contentMedia = `<div class="product-single__media product-single__media-native-video" data-media-id="${idMedia}" 
                        style="--aspect-ratio: 1.25" id="Media-Thumbnails-${section}-${idMedia}">
                          <video playsinline="playsinline" controls="controls" loading="lazy" preload="metadata" aria-label="${product.title}" 
                            poster="${posterVideo}">
                            <source src="${video}" type="video/mp4">
                            <img src="${posterVideo}">
                          </video>
                        </div>`
            }

            if (typeMedia == "IMAGE") {
                contentMedia = `<div class="product-single__media product-single__media-image aspect-ratio aspect-ratio--adapt"
                        id="Media-Thumbnails-${section}-${idMedia}"
                        style="--padding-bottom: 80.0%;">
                        <img class="lazyload no-blur" width="3200" height="2560" data-sizes="auto"
                            src="${media.previewImage.url}?width=600&format=webp&quality=80"
                            fetchpriority="high" alt="${media.previewImage.altText}" sizes="800px">
                        <a href="${media.previewImage.url}?width=600&format=webp&quality=80" class="product-single__media-zoom"
                            data-msrc="${media.previewImage.url};width=20" data-h="2560"
                            data-w="3200" target="_blank" tabindex="-1" data-index="${index}" aria-label="Zoom">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.375 4.0625H15.9375V7.625" stroke="var(--color-body)" stroke-width="1.3"
                                    stroke-linecap="round" stroke-linejoin="round"></path>
                                <path d="M11.7812 8.21875L15.9375 4.0625" stroke="var(--color-body)" stroke-width="1.3"
                                    stroke-linecap="round" stroke-linejoin="round"></path>
                                <path d="M7.625 15.9375H4.0625V12.375" stroke="var(--color-body)" stroke-width="1.3"
                                    stroke-linecap="round" stroke-linejoin="round"></path>
                                <path d="M8.21875 11.7812L4.0625 15.9375" stroke="var(--color-body)" stroke-width="1.3"
                                    stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                        </a>
                        ${badgesVariant()}
                    </div>`
            }

            const htmlMedia =
                `<div id="Slide-${section}-${idMedia}"
                    class="product-images__slide product-images__slide--image is-active ${classVariante} ${isActiveClass}"
                    data-media-id="${section}-${idMedia}" 
                    ${dataSetName ? `data-set-name="${dataSetName}"` : ''}
                    ${dataGroup ? `data-group="${dataGroup}"` : ''}>
                    ${contentMedia}
                </div>`
            sliderContainer.innerHTML += htmlMedia;
        });
        //change metafields product_details
        const detailsMetafield = product.metafields.find(
            mf => mf?.key === 'product_details' && mf?.namespace === 'custom'
        );
        const detailsHtml = detailsMetafield
            ? convertSchemaToHtml(detailsMetafield.value, { scoped: 'rte' })
            : '';
        if (detailsMetafield) {
            const container = document.querySelector('.collapsible__content--details');
            if (container) {
                const div = container.querySelector('.metafield-rich_text_field') || (() => {
                    const el = document.createElement('div');
                    el.className = 'metafield-rich_text_field';
                    container.appendChild(el);
                    return el;
                })();
                div.innerHTML = detailsHtml;
            }
        }
        //change metafields product_shipping_returns
        const shippingReturnsMetafield = product.metafields.find(
            mf => mf?.key === 'product_shipping_returns' && mf?.namespace === 'custom'
        );
        const shippingReturnsHtml = shippingReturnsMetafield
            ? convertSchemaToHtml(shippingReturnsMetafield.value, { scoped: 'rte' })
            : '';
        if (shippingReturnsMetafield) {
            const shippingReturnsContainer = document.querySelector('.collapsible__content--shipping_returns');
            if (shippingReturnsContainer) {
                const div = shippingReturnsContainer.querySelector('.metafield-rich_text_field') || (() => {
                    const el = document.createElement('div');
                    el.className = 'metafield-rich_text_field';
                    shippingReturnsContainer.appendChild(el);
                    return el;
                })();
                div.innerHTML = shippingReturnsHtml;
            }
        }
        //change metafields product_dimension_image
        const dimensionImageMetafield = product.metafields.find(
            mf => mf?.key === 'product_dimension_image' && mf?.namespace === 'custom'
        );

        if (dimensionImageMetafield && dimensionImageMetafield.reference && dimensionImageMetafield.reference.image) {
            const imageUrl = dimensionImageMetafield.reference.image.src || dimensionImageMetafield.reference.image.url;
            const imageAlt = dimensionImageMetafield.reference.image.altText || '';

            const imageElement = document.querySelector('.collapsible__content--dimension .custom_image_preview');
            if (imageElement) {
                imageElement.src = imageUrl;
                imageElement.alt = imageAlt;
            }
        }

        scrollToTop();
        setTimeout(() => {
            selectedVariant(productVariantSelected);
            updateStartReviewElement(productHandle, productId);
        }, 700);

        const productShopify = await fetchProductShopify(productHandle);
        const scriptElement = document.querySelector('script[data-product="product-data"]');
        if (scriptElement) {
            scriptElement.remove();
        }
        const newScriptElement = document.createElement('script');
        newScriptElement.type = 'application/json';
        newScriptElement.dataset.product = 'product-data';
        newScriptElement.textContent = JSON.stringify(productShopify.variants);
        document.querySelector('.variations').appendChild(newScriptElement);

        document.querySelector(".featured-collection-influencers-opacity-loading").classList.remove("is-loading");
    }

    /**
     * Updates the start_review element with new product handle
     * @param {string} productHandle - The handle of the product
     */
    async function updateStartReviewElement(productHandle, productId) {
        const startReviewLink = document.querySelector('.shopify-app-block-start-review a[href="#looxReviews"]');
        if (startReviewLink) {
            const handleDiv = startReviewLink.querySelector('div');
            if (handleDiv) {
                handleDiv.setAttribute('data-handle', productHandle);
            }

            const reviewsContent = await fetchLooxReviewsContent(`/products/${productHandle}`);
            const looxSection = document.querySelector('.custom-loox-reviews');

            if (reviewsContent) {
                updateCustomReviewLoox(productId);
                if (looxSection) {
                    looxSection.style.display = 'block';
                }
            } else {
                if (looxSection) {
                    looxSection.style.display = 'none';
                }
            }
        }
    }

    /**
     * Updates the custom-review-loox iframe with new product ID
     * @param {string} productId - The ID of the product (numeric)
     */
    function updateCustomReviewLoox(productId) {
        const looxIframe = document.querySelector('#looxReviews');
        if (looxIframe && productId) {
            // Update data-src for lazy loading
            const newDataSrc = `https://loox.io/widget/0OP0G_iOlB/reviews/${productId}`;
            looxIframe.setAttribute('data-src', newDataSrc);
            // If iframe is already loaded, update src directly
            if (looxIframe.src) {
                looxIframe.src = newDataSrc;
            }
        }
    }

    function scrollToTop() {
        document.getElementById('product-handle').scrollIntoView();
    }

    function saveProductToLocalStorage(productHandle) {
        localStorage.setItem('selectedProductHandle', JSON.stringify(`${productHandle}`));
    }

    function removeProductFromLocalStorage() {
        localStorage.removeItem('selectedProductHandle');
    }

    function selectedVariant(productVariantSelected = null) {

        document.querySelectorAll('.variations fieldset').forEach((fieldset) => {
                const selector = productVariantSelected
                    ? `div[style*="position: relative"][style*="margin-bottom: 10px"][data-variant-id="${productVariantSelected}"]`
                    : `div[style*="position: relative"][style*="margin-bottom: 10px"]`;

                const targetDiv = fieldset.querySelector(selector);
                targetDiv?.querySelector('label')?.click();
        });
    }

    removeProductFromLocalStorage();

    const addToCartButton = document.getElementById('AddToCart');

    if (addToCartButton) {
        addToCartButton.classList.add('not-klaviyo');
    }

});
